<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class style="position: relative;margin-top: 30px;">
        <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
          <a-form-item label="触发类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-select @change="typeChanged" v-model="info.type">
              <!-- <a-select-option :value="0">学分</a-select-option> -->
              <a-select-option :value="1">学时</a-select-option>
              <a-select-option :value="2">课程</a-select-option>
              <a-select-option :value="3">考试</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="课程学分"
            v-if="info.type==0"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-input
              placeholder="请输入课程学分"
              v-decorator="[
                'value',
                {rules: [{ required: true, message: '请输入课程学分!' }],initialValue:info.value}
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="课程学时"
            v-if="info.type==1"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-input
              placeholder="请输入课程学时"
              v-decorator="[
                'value',
                {rules: [{ required: true, message: '请输入课程学时!' }],initialValue:info.value}
              ]"
            ></a-input>
          </a-form-item>

          <a-form-item
            label="关联课程"
            v-if="info.type==2"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-button
              type="primary"
              :style="{ margin: '5px'}"
              class="ui-search-action"
              @click="chooseCourse()"
            >选择课程</a-button>
            <a-table
              :columns="courseInfo.columns"
              rowKey="id"
              :pagination="false"
              :dataSource="courseInfo.datas"
              :loading="isloading"
              size="small"
            >
              <span slot="status" slot-scope="status">
                <a-tag v-if="status==1" color="green">已发布</a-tag>
                <a-tag v-else-if="status==-1" color="red">未发布</a-tag>
                <a-tag v-else-if="status==2" color="red">直播中</a-tag>
                <a-tag v-else-if="status==3" color="green">已结束</a-tag>
                <a-tag v-else color="gray">已删除</a-tag>
              </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn name="移除" size="small" @click="removeCourse(info.id)" type="default" />
              </span>
            </a-table>
          </a-form-item>
          <a-form-item
            label="关联考试"
            v-if="info.type==3"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-button
              type="primary"
              :style="{ margin: '5px'}"
              class="ui-search-action"
              @click="chooseExam()"
            >选择考试</a-button>
            <a-table
              :columns="examInfo.columns"
              rowKey="id"
              :pagination="false"
              :dataSource="examInfo.datas"
              :loading="isloading"
              size="small"
            >
              <span slot="status" slot-scope="status">
                <a-tag v-if="status==0" color="blue">未发布</a-tag>
                <a-tag v-else-if="status==1" color="green">进行中</a-tag>
                <a-tag v-else color="red">已结束</a-tag>
              </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn name="移除" size="small" @click="removeExam(info.id)" type="default" />
              </span>
            </a-table>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 21, offset: 3 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
      <a-modal
        v-model="chooseCourseShow"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <courseChoose @callbackMethod="addCourse" :ids="info.targetIds" />
      </a-modal>

      <a-modal
        v-model="chooseExamShow"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <testChoose @callbackMethod="addExam" :ids="info.targetIds" />
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import courseChoose from "../train/courseChoose.vue";
import testChoose from "../train/testChoose.vue";

const courseColumns = [
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "课程名称",
  },

  {
    dataIndex: "typeName",
    key: "typeName",
    align: "center",
    title: "课程分类",
  },
  {
    dataIndex: "presentPrice",
    key: "presentPrice",
    align: "center",
    title: "价格/元",
  },
  {
    dataIndex: "teacherName",
    key: "teacherName",
    align: "center",
    title: "讲师",
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];

const examColumns = [
  {
    dataIndex: "testName",
    key: "testName",
    align: "center",
    title: "考试名称",
  },
  {
    dataIndex: "questionsCount",
    key: "questionsCount",
    align: "center",
    title: "题目数量",
  },
  {
    dataIndex: "passLine",
    key: "passLine",
    align: "center",
    title: "及格分数线",
  },
  {
    dataIndex: "examStatus",
    key: "examStatus",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];
var that;
export default {
  name: "trigger",
  props: {
    id: String,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      courseInfo: {
        columns: courseColumns,
        datas: [],
      },
      examInfo: {
        columns: examColumns,
        datas: [],
      },
      info: {
        type: 1,
        targetIds: [],
        courseIds: "",
        examIds: "",
      },
      chooseCourseShow: false, //选择课程
      chooseExamShow: false, // 选择考试
      courseIds: "",
      isloading: false,
      loadingTip: "加载中...",
    };
  },
  components: {
    courseChoose,
    testChoose
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      this.getTrigger();
    });
  },
  methods: {
    getInfo() {
      this.$api.certificate
        .getById(this.id)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.courseIds = res.data.courseIds;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    chooseCourse() {
      this.chooseCourseShow = true;
    },
    removeCourse(id) {
      this.$confirm({
        title: "提示",
        content: "您确定要移除课程吗",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          for (let i = 0; i < that.info.targetIds.length; i++) {
            if (id == that.info.targetIds[i]) {
              that.info.targetIds.splice(i, 1);
              break;
            }
          }
          that.info.courseIds = that.info.targetIds.join();
          that.getCourseListByIds();
        },
        onCancel() {},
      });
    },
    addCourse(ids) {
      this.chooseCourseShow = false;
      this.info.courseIds = ids;
      console.log(this.info.targetIds)
      this.getCourseListByIds();
    },
    chooseExam() {
      this.chooseExamShow = true;
    },
    removeExam(id) {
      this.$confirm({
        title: "提示",
        content: "您确定要移除考试吗",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          for (let i = 0; i < that.info.targetIds.length; i++) {
            if (id == that.info.targetIds[i]) {
              that.info.targetIds.splice(i, 1);
              break;
            }
          }
          that.info.examIds = that.info.targetIds.join();
          that.getExamListByIds();
        },
        onCancel() {},
      });
    },
    addExam(ids) {
      this.chooseExamShow = false;
      this.info.examIds = ids;
      this.getExamListByIds();
    },
    typeChanged(v) {
      if (v ==2||v==3) {
        this.info.targetIds = [];
      }
    },
    getTrigger() {
      this.isloading = true;
      this.$api.certificate
        .getTrigger(this.id)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            if (res.data.trigger) {
              this.info = res.data.trigger;
              if (this.info.targetIds) {
                this.info.targetIds = this.info.targetIds;
              }
              if (this.info.type == 2) {
                this.info.courseIds = this.info.targetIds.join();
                this.getCourseListByIds();
              }
              if (this.info.type == 3) {
                this.info.examIds = this.info.targetIds.join();
                this.getExamListByIds();
              }
            }
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isloading = true;
          this.$api.certificate
            .setTrigger(
              this.id,
              this.info.type,
              values.value,
              this.info.targetIds ? this.info.targetIds.join(",") : ""
            )
            .then((res) => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
                this.$emit("callbackMethod", true);
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    getCourseListByIds() {
      this.isloading = true;
      this.$api.course
        .getCourseListByIds(this.info.courseIds)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.courseInfo.datas = res.data;
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    getExamListByIds() {
      this.isloading = true;
      this.$api.examination
        .getExamListByIds(this.info.examIds)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.examInfo.datas = res.data;
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
  },
};
</script>
<style>
</style>